export const DEVICES_SERVICE_TYPE = 'Kiemelt Készülék';
export const BUSINESS_SERVICE_TYPE = 'Üzleti szolgáltatások';

export const BASKET_ITEM_TYPES = {
	SERVICE: 'SZOLGALTATAS',
	PRODUCT: 'TERMEK'
};

export const SERVICE_TYPES = {
	MOBIL: 'mobil',
	MOBIL_INTERNET: 'mobil-internet',
	KOMBI: 'kombi',
	INTERNET: 'internet',
	TV: 'tv',
	TELEFON: 'telefon',
	DKTV: 'dktv'
};

export const KOMBI_CSOMAG_SERVICE_TYPES = {
	INTERNET: 'internet',
	TV: 'tv',
	TELEFON: 'telefon'
};

export const TITLE_MASKED_FILTER_TYPES = {
	DOTTED_NUMBER: 3,
	DOTTED_CHARS: '...',
	SMALL_LIMIT_NUMBER: 24,
	LONG_LIMIT_NUMBER: 32
};

export const QUERY_PARAMS_KEY = 'queryFilter';
export const HAS_SAVED_PARAMS_KEY = 'hasSaved';
export const SETTINGS_LOCAL_STORAGE_NAME = 'settings';
export const OVERFLOW_HIDDEN = 'is-modal-overflow-hidden';
export const POPUP_OPEN = 'modal-open';

export const PRODUCTS_KEY = 'Készülékek';
export const SEVICES_KEY = 'Szolgáltatások';

export const CART_ITEM_TYPE = {
	PRODUCT: 'PRODUCT',
	SERVICE: 'SERVICE',
	WEBITEM: 'WEBITEM'
};

export const SERVICE_TYPE_CODE = {
	FIX_NET: 'Fix net',
	ANALOG_TV: 'Analóg TV',
	IP_TV_FO: 'IP TV Fő',
	IP_TV_AL: 'IP TV Al',
	MOBILTELEFON: 'Mobiltelefon',
	MOBILINTERNET: 'Mobilinternet',
	MOBILTV: 'MobilTV',
	TELEFON_MGCP: 'Telefon MGCP',
	DIGITALIS_TV: 'Digitális TV',
	HELYI_TV: 'Helyi TV'
};

export const MAIN_SERVICE_TYPES = [
	SERVICE_TYPE_CODE.FIX_NET,
	SERVICE_TYPE_CODE.ANALOG_TV,
	SERVICE_TYPE_CODE.TELEFON_MGCP
];

export const WEBITEM_TYPE = {
	SOLO_SZOLG: 'SOLO_SZOLG',
	KOMB_SZOLG: 'KOMB_SZOLG',
	PRODUCT: 'PRODUCT',
	DISCOUNT: 'DISCOUNT'
};

export const ERROR_CODES = {
	CONFLICT: 'conflict',
	SAME_SERVICE: 'sameService'
};

export const IMAGE_URL_PREFIX = '/sw/pic/';
export const SEARCH_IMAGE_PREFIX = `${IMAGE_URL_PREFIX}kereso_oldal/`;
export const MAIN_IMAGE_PREFIX = `${SEARCH_IMAGE_PREFIX}fokep/`;
export const ICON_IMAGE_PREFIX = `${SEARCH_IMAGE_PREFIX}ikon/`;
export const GREEN_ICON_IMAGE_PREFIX = `${SEARCH_IMAGE_PREFIX}zold_ikon/`;
export const PRODUCT_IMAGE_PREFIX = `${IMAGE_URL_PREFIX}termek_oldal/`;

export const SETTLEMENT_CONFIRMATION_MODAL_EVENT = {
	OPEN: 'open-settlement-confirmation-modal',
	CONFIRM: 'on-settlement-confirmation-modal-confirm-address-change',
	CANCEL: 'on-settlement-confirmation-modal-cancel-address-change'
};

// ugyfel portal kulso oldalak
export const RECAPTCHA_TOKEN_NAME = 'X-ReCaptcha-Token';
export const FACEBOOK_OAUTH_URI = 'https://www.facebook.com/v10.0/dialog/oauth';
export const FACEBOOK_LOGIN_REDIRECT_URI = window.location.origin + '/tarr/ugyfelkapu/public/users/facebook/login'; // security.xml - facebook-login-process-url
export const FACEBOOK_REGISTRATION_REDIRECT_URI = window.location.origin + '/tarr/ugyfelkapu/public/users/facebook/startregister'; // security.xml - facebook-start-registration-process-url
export const CUSTOMER_PORTAL_DEFAULT_ERROR = {FIELD_ID: 'general', MESSAGE: 'Váratlan hiba történt!'};

export const BUS01_BUTTON_PARENT = '.bus01-item';
export const DEFAULT_SELECTED_SERVICE = 'default-selected';
export const SCROLL_DURATION = 750;



// WEBPACK FOOTER //
// ../source/common/constants/constants.js